import {useParams} from 'react-router-dom';
import {useCustomPage} from './use-custom-page';
import {Navbar} from '../ui/navigation/navbar/navbar';
import {Footer} from '../ui/footer/footer';
import {CustomPageBody} from '@common/custom-page/custom-page-body';
import {PageMetaTags} from '@common/http/page-meta-tags';
import {PageStatus} from '@common/http/page-status';
import {useEffect} from 'react';

const PAGE_BANNERS: Record<string, {eyebrow: string; heading: string; sub: string}> = {
  'terms-of-service': {
    eyebrow: 'Legal',
    heading: 'Terms of Service',
    sub: 'Please read these terms carefully before using our platform. By accessing LinkInBio, you agree to be bound by these terms.',
  },
  'privacy-policy': {
    eyebrow: 'Legal',
    heading: 'Privacy Policy',
    sub: 'We value your privacy. This policy explains how we collect, use, and protect your personal information.',
  },
  'report-abuse': {
    eyebrow: 'Safety',
    heading: 'Report Abuse',
    sub: 'Help us keep the platform safe. Report any content or behaviour that violates our community guidelines.',
  },
};

interface Props {
  slug?: string;
}
export function CustomPageLayout({slug}: Props) {
  const {pageSlug} = useParams();
  const resolvedSlug = slug || pageSlug!;
  const query = useCustomPage(resolvedSlug);
  const banner = PAGE_BANNERS[resolvedSlug];

  useEffect(() => {
    if (query.data?.page) {
      window.scrollTo(0, 0);
    }
  }, [query]);

  return (
    <div style={{display: 'flex', flexDirection: 'column', minHeight: '100vh', background: '#f7f7f5'}}>
      <PageMetaTags query={query} />
      <Navbar color="bg" border="border-b" className="lp-sticky-nav flex-shrink-0" menuPosition="homepage-navbar" />

      {banner && (
        <div style={{backgroundColor:'#1a0800', backgroundImage:'radial-gradient(120% 120% at 0% 0%, #FFB23E 0%, transparent 50%), radial-gradient(120% 120% at 100% 0%, #FF2E63 0%, transparent 45%), radial-gradient(140% 140% at 50% 120%, #FF4F00 0%, transparent 60%)', padding: '64px 24px 72px', textAlign: 'center', position: 'relative', overflow: 'hidden'}}>
          <div style={{position: 'relative'}}>
            <span style={{display: 'inline-block', fontSize: 11, fontWeight: 700, letterSpacing: '0.18em', textTransform: 'uppercase', color: 'rgba(255,255,255,0.7)', marginBottom: 14}}>
              {banner.eyebrow}
            </span>
            <h1 style={{fontSize: 'clamp(28px, 5vw, 48px)', fontWeight: 800, color: '#fff', letterSpacing: '-0.02em', lineHeight: 1.1, margin: '0 0 16px'}}>
              {banner.heading}
            </h1>
            <p style={{fontSize: 16, color: 'rgba(255,255,255,0.65)', maxWidth: 520, margin: '0 auto', lineHeight: 1.7}}>
              {banner.sub}
            </p>
          </div>
        </div>
      )}

      <div style={{flex: 1}}>
        {query.data ? (
          <CustomPageBody page={query.data.page} hideTitle={!!banner} />
        ) : (
          <PageStatus query={query} loaderClassName="mt-80" />
        )}
      </div>

      <Footer className="mx-14 md:mx-40" />
    </div>
  );
}
